/**
 * Hero — atklāšana ritinot, ievadefekts un ritināšanas mājiens.
 *
 * Trīs neatkarīgas lietas vienā failā, jo visas trīs ir viena bloka uzvedība un
 * visas trīs ieslēdzas no ACF laukiem. Katra pārbauda savu āķi un, ja tā lapā
 * nav, neko nedara — tāpēc parastām lapām šis skripts ir tukšs izsaukums.
 *
 *   1. Atklāšana ritinot  (.hero-track)          — reveal_on_scroll
 *   2. Ievadefekta brāzma (.hero--intro)         — intro_effect = focus
 *   3. Ritināšanas mājiens (.hero__hint)         — tikai atklāšanas režīmā
 */
(function () {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    /* ── 1 · Atklāšana ritinot ──────────────────────────────────────────────────
       Katram elementam sava progresa daļa, tāpēc tie nāk SECĪGI. Pārklāšanās starp
       soļiem ir apzināta — bez tās elementi nāktu rāvieniem.
  
       Aptumšojums ir pirmais: tas parādās kopā ar tekstu, tāpēc tīrais attēls
       paliek redzams, kamēr vēl nav ko lasīt.
  
       Kāpēc ritināšanas pozīcija, ne IntersectionObserver: --reveal ir tīra pozīcijas
       funkcija, tāpēc atpakaļgaita nāk pati un solis nevar palikt iestrēdzis. */
    const RANGES = [
        { key: "scrim", from: 0.00, to: 0.22 },
        { key: "title", from: 0.10, to: 0.38 },
        { key: "accent", from: 0.30, to: 0.52 },
        { key: "lead", from: 0.40, to: 0.62 },
        { key: "actions", from: 0.52, to: 0.74 },
    ];
    function clamp(v) {
        return v < 0 ? 0 : v > 1 ? 1 : v;
    }
    /* smoothstep — bez tā elementi parādās lineāri un izskatās mehāniski. */
    function ease(t) {
        return t * t * (3 - 2 * t);
    }
    const tracks = Array.prototype.slice.call(document.querySelectorAll(".hero-track"));
    const groups = tracks.map(function (track) {
        return {
            track: track,
            hint: track.querySelector(".hero__hint"),
            steps: RANGES.map(function (r) {
                return {
                    from: r.from,
                    to: r.to,
                    el: track.querySelector('[data-reveal="' + r.key + '"], [data-reveal-fade="' + r.key + '"]'),
                };
            }),
        };
    });
    function render() {
        const vh = window.innerHeight;
        groups.forEach(function (g) {
            const rect = g.track.getBoundingClientRect();
            const span = rect.height - vh;
            const p = span <= 0 ? 1 : clamp(-rect.top / span);
            g.steps.forEach(function (s) {
                if (s.el) {
                    s.el.style.setProperty("--reveal", ease(clamp((p - s.from) / (s.to - s.from))).toFixed(3));
                }
            });
            /* Mājiens pazūd, tiklīdz sāk ritināt — tad tas savu darbu jau ir izdarījis. */
            if (g.hint) {
                g.hint.style.setProperty("--hint", p > 0.04 ? "0" : "1");
            }
        });
    }
    if (groups.length && !reduce) {
        let queued = false;
        const onScroll = function () {
            if (queued) {
                return;
            }
            queued = true;
            requestAnimationFrame(function () {
                queued = false;
                render();
            });
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        render();
    }
    /* ── 2 · Ievadefekta brāzma ────────────────────────────────────────────────
       Attēla nostāšanos dara CSS animācija; šeit tikai brāzmas atkārtošana.
       Klase jānoņem un jāpieliek atpakaļ ar piespiedu pārzīmēšanu starpā, citādi
       animācija nesākas no jauna — tas pats paņēmiens, ko lieto app.ts. */
    const introHosts = Array.prototype.slice.call(document.querySelectorAll(".hero--intro.gust-host"));
    if (introHosts.length && !reduce) {
        introHosts.forEach(function (host) {
            const fire = function () {
                host.classList.remove("is-in");
                void host.offsetWidth;
                host.classList.add("is-in");
                window.setTimeout(fire, 6000 + Math.random() * 4000);
            };
            /* 600ms: brāzma sākas, kamēr attēls vēl nostājas — abi kopā lasās kā viens
               ievads, nevis divi atsevišķi efekti. */
            window.setTimeout(fire, 600);
        });
    }
    /* ── 3 · Ritināšanas mājiens ───────────────────────────────────────────────
       Parādās PĒC ievada, lai nesacenstos ar attēla nostāšanos. Ja cilvēks jau
       ritina, tas neparādās vispār — tad tas vairs neko nepasaka. */
    const hints = Array.prototype.slice.call(document.querySelectorAll(".hero__hint"));
    hints.forEach(function (hint) {
        const hero = hint.closest(".hero");
        const delay = !reduce && hero && hero.classList.contains("hero--intro") ? 1200 : 0;
        if (!delay) {
            hint.classList.add("is-ready");
            return;
        }
        window.setTimeout(function () {
            if (window.scrollY < 8) {
                hint.classList.add("is-ready");
            }
        }, delay);
    });
})();
